<template>
  <div class="container mt-4">
    <h2>Statistik</h2>
    <!-- <div class="center">
      <b-button @click="animateCounters">Animimation starten</b-button>
    </div> -->
    <h3>Bewerbungen {{ year }}</h3>
    <div class="card-wrapper">
      <div v-for="stat in currentStats" :key="stat.id" class="card">
        <div class="card_title">
          <h4>{{ stat.job }}</h4>
        </div>
        <div class="count-number_container">
          <span class="animate_count-number" :id="`id_${stat.id}`"> 0 </span>
        </div>
      </div>
    </div>
    <hr />
    <div>
      <b-form-group label="Vergangene Jahre anzeigen:">
        <b-form-select
          v-model="selectedYear"
          @change="loadStatsByYear(selectedYear)"
        >
          <option
            v-for="yearOption in yearOptions"
            :key="yearOption"
            :value="yearOption"
          >
            {{ yearOption }}
          </option>
        </b-form-select>
      </b-form-group>
    </div>
    <h3 v-if="selectedYear">Bewerbungen {{ selectedYear }}</h3>
    <div class="card-wrapper" v-if="pastStats.length">
      <div v-for="stat in pastStats" :key="stat.id" class="card">
        <div class="card_title">
          <h4>{{ stat.job }}</h4>
        </div>
        <div class="count-number_container">
          <span class="animate_count-number" :id="`id_${stat.id}`">
            {{ stat.count }}
          </span>
        </div>
      </div>
    </div>
    <button @click="countOldApplications" style="visibility: hidden;">Alte Bewerbungen laden</button>
  </div>
</template>

<script>
import {
  collection,
  onSnapshot,
  doc as firebaseDocument,
  getDoc,
  //increment,
  updateDoc,
  setDoc,
  getDocs,
} from "firebase/firestore";
import { firestore } from "../plugins/firebase";

export default {
  name: "StatsView",
  data() {
    return {
      currentStats: [],
      year: new Date().getFullYear(),
      pastStats: [],
      allYears: [],
      selectedYear: null,
    };
  },
  computed: {
    yearOptions() {
      return Array.from(new Set(this.allYears)).sort((a, b) => b - a);
    },
  },
  methods: {
    animateCounters() {
      this.currentStats.forEach((stat) => {
        const element = document.getElementById(`id_${stat.id}`);
        if (!element) return;

        element.textContent = "0";

        const timeOut = setTimeout(() => {
          clearTimeout(timeOut);
        }, 1000);

        const start = 0;
        const end = stat.count;
        const duration = 1000;
        const stepTime = Math.abs(Math.floor(duration / (end - start)));
        let current = start;

        const timer = setInterval(() => {
          current += 1;
          element.textContent = current;
          if (current >= end) {
            clearInterval(timer);
          }
        }, stepTime);
      });
    },
    loadStatsByYear(year) {
      const colRef = collection(firestore, "counters");
      onSnapshot(colRef, (snapshot) => {
        const statsData = [];
        snapshot.forEach((doc) => {
          if (doc.id.slice(doc.id.lastIndexOf("_") + 1) != year) return;
          statsData.push({
            id: doc.id,
            count: doc.data().count,
            job: doc.data().jobOffer,
          });
        });
        this.pastStats = statsData;
      });
    },
    async countOldApplications() {
      const applicationsRef = collection(firestore, "application");
      const applicationDocs = await getDocs(applicationsRef);
      for (const doc of applicationDocs.docs) {
        const data = doc.data();
        const incomingDate = data.incoming.toDate();
        if (!data.countedInStats) {
          const year = new Date(incomingDate).getFullYear().toString();
          const counterRef = firebaseDocument(
            collection(firestore, "counters"),
            `applications_${data.jobOfferName
              .replace(/[ /]/g, "_")
              .replace(/ /g, "_")}_${year}`
          );
          await getDoc(counterRef).then(async (counterDoc) => {
            if (!counterDoc.exists()) {
              await setDoc(counterRef, {
                count: 1,
                jobOffer: data.jobOfferName,
              });
            } else {
              const currentCount = counterDoc.data().count || 0;
              await updateDoc(counterRef, {
                count: currentCount + 1,
              });
            }
          });
          await updateDoc(
            doc.ref,
            {
              countedInStats: true,
            },
            { merge: true }
          );
          console.log(
            `Application ID: ${doc.id} counted in stats for year ${year}.`
          );
        } else {
          console.log(
            `Application ID: ${doc.id} has already been counted in stats.`
          );
        }
      }
    },
  },
  mounted() {
    const colRef = collection(firestore, "counters");
    onSnapshot(colRef, (snapshot) => {
      const statsData = [];
      snapshot.forEach((doc) => {
        this.allYears.push(doc.id.slice(doc.id.lastIndexOf("_") + 1));
        if (doc.id.slice(doc.id.lastIndexOf("_") + 1) != this.year) return;
        statsData.push({
          id: doc.id,
          count: doc.data().count,
          job: doc.data().jobOffer,
        });
      });
      this.currentStats = statsData;
      this.$nextTick(() => {
        this.animateCounters();
      });
    });
  },
};
</script>

<style scoped>
h2 {
  text-align: center;
}
.center {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}
.card-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
  margin: 24px 0;
}
.card {
  width: 350px;
  height: 300px;
  text-align: center;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
}
.card_title {
  background-color: #4089c9;
  color: #fff;
  padding: 10px;
  border-bottom: 1px solid #ddd;
  font-size: 1rem;
  height: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.animate_count-number {
  text-align: center;
  padding: 20px;
  color: #fff;
}
.count-number_container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 250px;
  font-size: 3em;
  font-weight: bold;
  background-color: #4089c99b;
}
</style>
